import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/web-view/";

const getDataKartu = 'data-keanggotaan/kartu-anggota/';
const getDetailDataKartu = 'data-keanggotaan/kartu-anggota-by-no-anggota/';

class KartuAnggotaService {

    getDataKartu(idUser) {
        return axios.get(
            API_URL + getDataKartu + idUser, {
            headers: authHeader()
        });
    }
    
    getDetailDataKartu(noAnggota) {
        return axios.get(API_URL + getDetailDataKartu + noAnggota);
    }

}

export default new KartuAnggotaService();